import { LiveServerToolCall, Tool, Type } from "@google/genai";
import { useEffect } from "react";
import { useLiveAPIContext } from "../contexts/LiveAPIContext";

// Define learning platform tool declarations
export const learningTools: Tool[] = [
  {
    functionDeclarations: [
      {
        name: "render_chart",
        description: "Displays a data visualization chart for learning analytics.",
        parameters: {
          type: Type.OBJECT,
          properties: {
            chart_data: {
              type: Type.STRING,
              description: "JSON STRING representation of the chart data to render.",
            },
          },
          required: ["chart_data"],
        },
      },
      {
        name: "get_course_progress",
        description: "Retrieves learning progress for a specific course.",
        parameters: {
          type: Type.OBJECT,
          properties: {
            course_id: {
              type: Type.STRING,
              description: "The ID of the course to get progress for",
            },
          },
          required: ["course_id"],
        },
      },
    ],
  },
];

export function useToolHandler() {
  const { client } = useLiveAPIContext();

  useEffect(() => {
    const onToolCall = (toolCall: LiveServerToolCall) => {
      console.log("Tool call received:", toolCall);
      
      // Handle tool calls here
      toolCall.functionCalls?.forEach(async (fc) => {
        try {
          switch (fc.name) {
            case "render_chart":
              // Handle chart rendering
              console.log("Rendering chart with data:", fc.args);
              break;
            case "get_course_progress":
              // Handle course progress retrieval
              console.log("Getting course progress:", fc.args);
              break;
            default:
              console.warn("Unknown tool call:", fc.name);
          }
        } catch (error) {
          console.error("Error handling tool call:", error);
        }
      });
    };

    client.on("toolcall", onToolCall);
    return () => {
      client.off("toolcall", onToolCall);
    };
  }, [client]);

  return { learningTools };
}
